import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";

import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";
import MainFooter from "../components/layout/MainFooter";

const DefaultLayout = ({ children, noNavbar, noFooter, noSidebar, navigateToPath, show_menu }) => (
  <Container fluid>
    <Row>
      <MainSidebar navigateToPath={navigateToPath} />
      <Col
        className="main-content p-0"
        xs="12"
        tag="main"
      >
        {!noNavbar && <MainNavbar show_menu={show_menu} />}

        {children}
        {!noFooter && <MainFooter />}
      </Col>
    </Row>
  </Container>
);

DefaultLayout.propTypes = {
  /**
   * Whether to display the navbar, or not.
   */
  noNavbar: PropTypes.bool,
  /**
   * Whether to display the footer, or not.
   */
  noFooter: PropTypes.bool,
};

DefaultLayout.defaultProps = {
  noNavbar: false,
  noFooter: true,
  noSidebar: false,
  show_menu: false,
};

export default DefaultLayout;
